import { defineStore } from "pinia";

export const useClaimStore = defineStore('claim', {
  state: () => ({
    claim: {},
    claims: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setClaim(claim) {
      this.claim = claim
    },
    setClaims(claims) {
      this.claims = claims
    },
    addClaim(claim) {
      this.claims.unshift(claim)
    },
    updateClaim(claim) {
      let index = this.claims.findIndex(cl => cl.id === claim.id)
      this.claims.splice(index, 1, claim)
    },
    deleteClaim(claim) {
      let index = this.claims.findIndex(cl => cl.id === claim.id)
      this.claims.splice(index, 1)
    },
  },
});